import React, { useState, useEffect, Component, useLayoutEffect } from 'react';
import { NavLink as NavLinkRRD, Link } from 'react-router-dom';
import NumberFormat from 'react-number-format';
//import axios from "axios";
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
// reactstrap components
import { Product } from './Product.js';

import {
  Card,
  Button,
  NavLink,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  CardTitle,
  UncontrolledTooltip,
} from 'reactstrap';
import { useSelector } from 'react-redux';

export const Products = React.memo((props) => {
  const groupSelect = useSelector((state) => state.miga.GroupSelect);
  var data = props.data;
  var newsTemplate;
  var settings = props.settings;
  if (settings.slidesToShow != 1) {
    //settings.slidesToShow = props.carouselOptions.length;
    settings.slidesToShow = 3;
    settings.infinite = false;
    settings.slidesToScroll = 0;
  }

  if (data.length > 0) {
    newsTemplate = props.carouselOptions.map(function (item, index) {
      console.log('estiloss:  ' + groupSelect[index]);
      return (
        <div
          key={index}
          onClick={() => props.handleMovements(item.listMovements, index)}
        >
          <Product
            data={item}
            indextar={index}
            ocultarFiltro={item.ocultarFiltro}
            index={item.index}
            handleMovements={props.handleMovements}
            deleteTimeAlert={props.deleteTimeAlert}
          />
        </div>
      );
    });
  } else {
    newsTemplate = <p>Hoy no se han generado movimientos </p>;
  }

  if (props.carouselOptions.length > 0) {
    return (
      <div>
        <Slider {...settings}>{newsTemplate}</Slider>
      </div>
    );
  } else {
    return <div className="news ml-4 mr-4 mt-1">{newsTemplate}</div>;
  }
});
